import base64 from 'base-64';

import {
   SIGN_IN_USER,
   VERIFY_AUTH_USER,
   LOGOUT_USER
} from '../../constants/user';

import { toastrNotify } from '../../utils/Toastr';
import { setLocalStorage, setRemoveLocalStorage } from '../../functions/VLocalStorage';
import { actions_requests } from '../../requests';

const signInUser     = payload => { return { type: SIGN_IN_USER, payload }};
const verifyAuthUser = payload => { return { type: VERIFY_AUTH_USER, payload }};
const logoutUser     = payload => { return { type: LOGOUT_USER, payload }};

export const actionSignIn = ( email, password ) => {
   return ( dispatch, getState ) => {

      let url_request = process.env.REACT_APP_SIGN_IN;

      fetch( url_request, {
         headers: new Headers({
            "Authorization": `Basic ${base64.encode(`${email}:${password}`)}`
         }),
         method: 'POST'
      })
      .then( response => response.json())
      .then( respo => {

         if ( respo.response === 'success' ) {

            setLocalStorage(
               respo.data.id,
               respo.data.guid_user,
               respo.data.displayName,
               respo.data.avatar,
               respo.data.email,
               respo.data.token,
               respo.data.scopes
            );

            dispatch(signInUser({
               ...getState().user,
               data: respo.data
            }));
         } else if ( respo.response === 'Bad Request' ) {
            toastrNotify({ typeMessage: 'warning', message: respo.message, title: 'Validación'});
         }

      })
      .catch( err => {

         if ( err.response === 'Bad Request' ) {
            toastrNotify({ typeMessage: 'warning', message: err.message, title: 'Validación'});
         }
      });
      
   }
}

export const actionCheckAuth = () => {
   return ( dispatch, getState ) => {

      let url_request = process.env.REACT_APP_CHECK_AUTH;

      actions_requests(null, url_request, 'POST', 2 )
         .then( respo => {


            if ( respo.response === 'success' ) {

               setLocalStorage(
                  respo.data.id,
                  respo.data.guid_user,
                  respo.data.displayName,
                  respo.data.avatar,
                  respo.data.email,
                  respo.data.token,
                  respo.data.scopes
               );

               dispatch(verifyAuthUser({
                  ...getState().user,
                  data: respo.data
               }));

            }
         })
         .catch( err => {

            if ( err.response === 'Unauthorized' ) {
               setRemoveLocalStorage();
               dispatch(verifyAuthUser({
                  ...getState().user,
                  data: []
               }));
            }

         });
   }
}

export const actionLogout = () => {
   return ( dispatch, getState ) => {

      setRemoveLocalStorage();

      dispatch(logoutUser({
        ...getState().user,
        data: []
      }));

   }
}